import React from 'react';
import { Skeleton, Typography } from '@mui/material';
import CustomColumnStartList from './customColumnStartList';
import ErrorBoundary from './errorBoundary';

const styles = {
    tableSkeleton: {
        fontSize: 16
    }
};

const SKELETON_ROWS = 15;

const Message = ({ children }) => (
    <Typography variant="body2" color="text.secondary">{children}</Typography>
);

/**
 * Everything below a start list's page heading: the loading state, the table,
 * and the empty/error states.
 *
 * Shared so the website and the embeddable widget cannot drift — the only
 * difference between them is the chrome above this component.
 *
 * `startList` is the event's `options.<provider>.startList` slice (columns,
 * customColumns, customQuestions, groupBy); `provider` is a descriptor from
 * `startListProviders`.
 */
const StartListBody = ({
    provider,
    startList,
    records = [],
    loading = false,
    error = null,
    unavailable = false
}) => {
    if (unavailable) {
        return <Message>Start list unavailable.</Message>;
    }

    if (error) {
        return <Message>Start list is temporarily unavailable.</Message>;
    }

    if (loading) {
        return (
            <>
                <Typography variant="body2">
                    This data comes directly from the registration sites, it may take a few moments.
                </Typography>
                {new Array(SKELETON_ROWS).fill(0).map((_v, i) => (
                    <Skeleton variant="text" sx={styles.tableSkeleton} key={i} />
                ))}
            </>
        );
    }

    if (records.length === 0) {
        return <Message>No entries yet.</Message>;
    }

    return (
        <ErrorBoundary fallback={<Message>Start list unavailable.</Message>}>
            <CustomColumnStartList
                records={records}
                baseColumns={provider.baseColumns}
                customColumns={startList?.customColumns ?? []}
                customQuestions={startList?.customQuestions ?? []}
                columns={startList?.columns ?? []}
                groupBy={startList?.groupBy}
                resolveQuestion={provider.resolveQuestion}
                defaultSort={provider.defaultSort}
            />
        </ErrorBoundary>
    );
};

export default StartListBody;
